import EditModalContainer from "./EditModalContainer";

export default EditModalContainer;
